
import { Displayable } from 'django-rest-react';

export const STAGE_TIPO: Displayable[] = [
  { id: 'I', display: 'Invernale' },
];

export const LEZIONEPDF_TOPICS: Displayable[] = [
  { id: 'm', display: 'Meccanica' },
  { id: 't', display: 'Termodinamica' },
  { id: 'e', display: 'Elettromagnetismo' },
  { id: 'r', display: 'Relatività' },
  { id: 'f', display: 'Fluidodinamica' },
  { id: 'l', display: 'Laboratorio' },
  { id: 'o', display: 'Ottica' },
  { id: 'a', display: 'Matematica' },
  { id: 'g', display: 'Miscellanea' },
];

export const COUNTRY_CONTINENT: Displayable[] = [
  { id: 'OC', display: 'Oceania' },
  { id: 'EU', display: 'Europe' },
  { id: 'AF', display: 'Africa' },
  { id: 'NA', display: 'North America' },
  { id: 'AN', display: 'Antarctica' },
  { id: 'SA', display: 'South America' },
  { id: 'AS', display: 'Asia' },
];

export const DOMANDAISCRIZIONE_CLASSI: Displayable[] = [
  { id: '1', display: 'Prima' },
  { id: '2', display: 'Seconda' },
  { id: '3', display: 'Terza' },
  { id: '4', display: 'Quarta' },
  { id: '5', display: 'Quinta' },
];

export const DOMANDAISCRIZIONE_PARTECIPAZIONE_SENIGALLIA: Displayable[] = [
  { id: 'O', display: 'Oro' },
  { id: 'A', display: 'Argento' },
  { id: 'B', display: 'Bronzo' },
  { id: 'P', display: 'Partecipazione' },
  { id: 'N', display: 'Nessuna partecipazione' },
];

export const DOMANDAISCRIZIONE_STATO_AMMISSIONE: Displayable[] = [
  { id: 'cpt', display: 'Pretest consegnato' },
  { id: 'fpt', display: 'Pretest non superato' },
  { id: 'ppt', display: 'Pretest superato' },
  { id: 'cts', display: 'Test scritto consegnato' },
  { id: 'fts', display: 'Test scritto non superato' },
  { id: 'pts', display: 'Test scritto superato' },
  { id: 'fpo', display: 'Prova orale non superata' },
  { id: 'ppo', display: 'Prova orale superata' },
  { id: 'pr', display: 'Posto rifiutato' },
  { id: 'pa', display: 'Posto accettato' },
];

export const SCUOLA_TIPI_SCUOLA: Displayable[] = [
  { id: 'LS', display: 'Liceo Scientifico' },
  { id: 'LC', display: 'Liceo Classico' },
  { id: 'LA', display: 'Liceo artistico' },
  { id: 'LL', display: 'Liceo linguistico' },
  { id: 'LM', display: 'Liceo musicale e coreutico' },
  { id: 'LU', display: 'Liceo delle scienze umane' },
  { id: 'IT', display: 'Istituto tecnico' },
  { id: 'IP', display: 'Istituto professionale' },
  { id: 'SP', display: 'Scuola privata' },
];
